export * from './replace.directive';



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/directives/replace/index.ts